import { render, staticRenderFns } from "./TrainingManagementForm.vue?vue&type=template&id=57d45c12&scoped=true"
import script from "./TrainingManagementForm.vue?vue&type=script&lang=js"
export * from "./TrainingManagementForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d45c12",
  null
  
)

export default component.exports